import styled from 'styled-components'
import { progressiveBreakpoints } from '../../constants/theme'

const SiteContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  max-width: ${({ theme }) => theme.sizes.siteBaseWidth};
  padding: 0 1.5rem;
  align-self: center;
  box-sizing: border-box;

  @media ${progressiveBreakpoints.desktopSmall} {
    margin-top: ${({ bannerSpacing }) => (bannerSpacing ? '80px' : 'auto')};
  }

  @media ${progressiveBreakpoints.desktop} {
    padding: 0;
  }
`

export default SiteContainer
